import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import { Desktop } from '../../../media'
import Anchor from '../../../components/anchor'
import { connect } from "react-redux";

import employeeService from '../../../services/Employee.service'

const Wrapper = styled.footer`
  background: #DDDDDD;
  box-shadow: 0 -1px 0 0 #CCCCCC;
  font-family: Lato-Regular;
  font-size: 14px;

  padding-left: 15px;
  padding-top: 14px;
  padding-bottom: 16px;

  // Desktop version.
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div {
    margin-left: 14px;
    margin-right: 14px;
    height: 30px;
    border-right: 1px solid #999999;
  }

  a {
    color: #1D71BB;
    text-decoration: none;
    line-height: 16px;

    // Mobile version.
    @media (max-width: 768px) {
      line-height: 30px;
      display: block;
    }
  }
`

export class Footer extends Component {
  render() {
    const { t, employee } = this.props;

    return (
      <Wrapper className="footer">
        { !employeeService.isBrokerChoiceOne(employee) &&
          <Anchor to="https://nb.fidelity.com/public/nb/default/resourceslibrary/articles/HowtoContactaFidelitySPSRep" target="_blank" className="contact-fidelity">{t('Footer.ContactFidelity')}</Anchor>
        }
        { !employeeService.isBrokerChoiceOne(employee) &&
          <Desktop>
            <div>
            </div>
          </Desktop>
        }
        <Anchor to="https://www.morganstanley.com/msatwork/amazon/en/contact.html" target="_blank" className="contact-morgan-stanley">{t('Footer.ContactMorgan')}</Anchor>
        <Desktop>
          <div>
          </div>
        </Desktop>
        <Anchor to="https://amazonvoe.eu.qualtrics.com/jfe/form/SV_9B3uT8ztFvrMF0x" target="_blank" className="submit-ticket">{t('Footer.ProvideFeedback')}</Anchor>
      </Wrapper>
    )
  }
}
const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(Footer));
